import React, { Component } from 'react';
import * as _ from 'lodash';
import Validator from 'validatorjs';
import { Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import Loading from '../../../../facturotopia/loading/Loading';
import EstadosCatalog from '../../../../support/catalogs/EstadosCatalog.json';
import { UsoDeCfdiCatalog } from '../../../../support/catalogs/UsoCfdiCatalog';
import NominaCatalogoManager from '../../../catalogs/managers/NominaCatalogoManager';

class ReceptorNominaInfoForm extends Component {

  state = {}

  constructor(props) {
    super(props);

    const validator = new Validator({}, this.rules);
    const baseState = props.data || {};

    this.state = {
      validator,
      ...baseState
    };

    const catalog = UsoDeCfdiCatalog.map(item => {
      return {
        label: `${item.descripcion} (${item.clave})`,
        value: item.clave
      }
    });

    this.usoCfdiCatalog = _.sortBy(catalog, 'label');
  }

  get rules() {
    const { data = {} } = this.props;

    const tipoRegimenInRules = ['01','02','03','04','05','06','07','08'].indexOf(data?.TipoContrato || '') !== -1
      ? 'in:02,03,04'
      : 'in:05,06,07,08,09,10,11,12,13,99';

    return {
      Curp: [
        'required',
        'string',
        'size:18',
        'regex:/^[A-Z][AEIOUX][A-Z]{2}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[MH]([ABCMTZ]S|[BCJMOT]C|[CNPST]L|[GNQ]T|[GQS]R|C[MH]|[MY]N|[DH]G|NE|VZ|DF|SP)[BCDFGHJ-NP-TV-Z]{3}[0-9A-Z][0-9]$/',
      ],
      NumSeguridadSocial: [
        'required',
        'string',
        'min:1',
        'max:15',
        'regex:/^[0-9]{1,15}$/',
      ],
      FechaInicioRelLaboral: [
        'required',
        'date',
        'regex:/^((19|20)[0-9][0-9])-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/',
      ],
      TipoContrato: [
        'required',
        'string',
        'in:01,02,03,04,05,06,07,08,09,10,99',
      ],
      Sindicalizado: [
        'string',
        'in:Sí,No',
      ],
      TipoJornada: [
        'string',
        'in:01,02,03,04,05,06,07,08,99',
      ],
      TipoRegimen: [
        'required',
        'string',
        tipoRegimenInRules
      ],
      NumEmpleado: [
        'required',
        'string',
        'min:1',
        'max:15',
        'regex:/^[^|]{1,15}$/',
      ],
      Departamento: [
        'string',
        'min:1',
        'max:100',
        'regex:/^[^|]{1,100}$/',
      ],
      Puesto: [
        'required',
        'string',
        'min:1',
        'max:100',
        'regex:/^[^|]{1,100}$/',
      ],
      RiesgoPuesto: [
        'required',
        'integer',
        'in:1,2,3,4,5,99',
      ],
      PeriodicidadPago: [
        'required',
        'string',
        'in:01,02,03,04,05,06,07,08,09,10,99',
      ],
      Banco: [
        'string',
        'in:002,006,009,012,014,019,021,030,032,036,037,042,044,058,059,060,062,072,102,103,106,108,110,112,113,116,124,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,143,145,147,148,149,150,151,152,153,154,155,156,157,158,159,160,166,168,600,601,602,605,606,607,608,610,614,615,616,617,618,619,620,621,622,623,626,627,628,629,630,631,632,633,634,636,637,638,640,642,646,647,648,649,651,652,653,655,656,659,670,901,902'
      ],
      CuentaBancaria: [
        'string',
        'regex:/^[0-9]{10,18}$/',
      ],
      SalarioBaseCotApor: [
        'required',
        'decimal:2',
        'min:0.00',
        'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/',
      ],
      SalarioDiarioIntegrado: [
        'required',
        'required_with:Emisor.RegistroPatronal',
        'decimal:2',
        'min:0.00',
        'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/',
      ],
      ClaveEntFed: [
        'required',
        'string',
        'in:AGU,BCN,BCS,CAM,CHP,CHH,COA,COL,CMX,DIF,DUR,GUA,GRO,HID,JAL,MEX,MIC,MOR,NAY,NLE,OAX,PUE,QUE,ROO,SLP,SIN,SON,TAB,TAM,TLA,VER,YUC,ZAC,AL,AK,AZ,AR,CA,NC,SC,CO,CT,ND,SD,DE,FL,GA,HI,ID,IL,IN,IA,KS,KY,LA,ME,MD,MA,MI,MN,MS,MO,MT,NE,NV,NJ,NY,NH,NM,OH,OK,OR,PA,RI,TN,TX,UT,VT,VA,WV,WA,WI,WY,ON,QC,NS,NB,MB,BC,PE,SK,AB,NL,NT,YT,UN',
      ],
    }
  }

  get sindicalizadoOptions() {
    return [
      {
        label: 'No',
        value: 'No'
      },
      {
        label: 'Sí',
        value: 'Sí'
      }
    ];
  }

  async componentDidMount() {
    await NominaCatalogoManager.boot();

    await this.fillCatalogs();

    setTimeout(() => {
      this.setState({
        loaded: true
      });
    }, 0);
  }

  fillCatalogs = async () => {
    if (!this.state.catalogos) {
      let catalogos = {};

      const estados = _.filter(EstadosCatalog, { pais: 'MEX' });

      const sorted = _.sortBy(estados.map((item) => {
        return {
          label: item.nombre_estado,
          value: item.estado
        }
      }), 'label');

      catalogos.estados = [{
        label: '',
        value: undefined
      }].concat(sorted);

      let values = await NominaCatalogoManager.get('c_nom_tipo_regimen');

      if (!!values) {
        const sorted = _.sortBy(values.map((item) => {
          return {
            label: item.descripcion,
            value: item.tipo
          }
        }), 'label');

        catalogos.tipoRegimen = [{
          label: '',
          value: undefined
        }].concat(sorted);
      }

      values = await NominaCatalogoManager.get('c_nom_periodicidad_pago');

      if (!!values) {
        const sorted = _.sortBy(values.map((item) => {
          return {
            label: item.descripcion,
            value: item.periodicidad
          }
        }), 'label');

        catalogos.periodicidadPago = [{
          label: '',
          value: undefined
        }].concat(sorted);
      }

      values = await NominaCatalogoManager.get('c_nom_tipo_contrato');

      if (!!values) {
        const sorted = _.sortBy(values.map((item) => {
          return {
            label: item.descripcion,
            value: item.tipo
          }
        }), 'label');

        catalogos.tipoContrato = [{
          label: '',
          value: undefined
        }].concat(sorted);
      }

      values = await NominaCatalogoManager.get('c_nom_tipo_jornada');

      if (!!values) {
        const sorted = _.sortBy(values.map((item) => {
          return {
            label: item.descripcion,
            value: item.tipo
          }
        }), 'label');

        catalogos.tipoJornada = [{
          label: '',
          value: undefined
        }].concat(sorted);
      }

      values = await NominaCatalogoManager.get('c_nom_riesgo_puesto');

      if (!!values) {
        const sorted = _.sortBy(values.map((item) => {
          return {
            label: item.descripcion,
            value: item.riesgo
          }
        }), 'label');

        catalogos.riesgoPuesto = [{
          label: '',
          value: undefined
        }].concat(sorted);
      }

      values = await NominaCatalogoManager.get('c_nom_banco');

      if (!!values) {
        const sorted = _.sortBy(values.map((item) => {
          return {
            label: item.descripcion,
            value: item.banco
          }
        }), 'label');

        catalogos.banco = [{
          label: '',
          value: undefined
        }].concat(sorted);
      }

      this.setState({
        catalogos
      });
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    if (!!data.rfc && data.rfc.length >= 12) {
      this.setRegimes(data.rfc);
    }

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step: this.props.step,
      isValid: validator.passes()
    });
  }

  render() {
    const { data = {}, autoFocus } = this.props;
    const { catalogos = {} } = this.state;

    const rules = this.rules;

    if (!this.state.loaded) {
      return <Loading className="m-5" />;
    }

    return (
      <Form autoComplete="off" data-testid="NominaForm">

        <Row className="py-3">
          <Col>
            <strong className="text-muted text-upper">Datos personales</strong>
          </Col>
        </Row>

        <Row>

          <Col sm="12" md="4">
            <FormControl type="text"
              label="Número de empleado"
              name="NumEmpleado"
              placeholder=""
              help=""
              minLength="1"
              maxLength="15"
              autoFocus={ autoFocus }
              rules={ rules.NumEmpleado }
              value={ data.NumEmpleado }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm="12" md="4">
            <FormControl type="text"
              label="CURP"
              name="Curp"
              placeholder=""
              help=""
              casing={ 'upper' }
              rules={ rules.Curp }
              value={ data.Curp }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm="12" md="4">
            <FormControl type="text"
              label="Número de Seguridad Social"
              name="NumSeguridadSocial"
              placeholder=""
              help=""
              rules={ rules.NumSeguridadSocial }
              value={ data.NumSeguridadSocial }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row className="py-3">
          <Col>
            <strong className="text-muted text-upper">Datos laborales</strong>
          </Col>
        </Row>

        <Row>

          <Col sm="12" md="4">
            <FormControl type="text"
              label="Fecha Inicio de Relación Laboral"
              name="FechaInicioRelLaboral"
              placeholder=""
              help=""
              rules={ rules.FechaInicioRelLaboral }
              value={ data.FechaInicioRelLaboral }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm="12" md="4">
            <FormControl type="select"
              label="Régimen"
              id="TipoRegimen"
              name="TipoRegimen"
              placeholder=""
              help=""
              rules={ rules.TipoRegimen }
              value={ data.TipoRegimen }
              options={ catalogos.tipoRegimen || [] }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm="12" md="4">
            <FormControl type="text"
              label="Puesto"
              name="Puesto"
              placeholder=""
              help=""
              rules={ rules.Puesto }
              value={ data.Puesto }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm="12" md="4">
            <FormControl type="select"
              label="Riesgo Puesto"
              name="RiesgoPuesto"
              placeholder=""
              help=""
              rules={ rules.RiesgoPuesto }
              value={ data.RiesgoPuesto }
              options={ catalogos.riesgoPuesto }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm="12" md="4">
            <FormControl type="text"
              label="Departamento"
              name="Departamento"
              placeholder=""
              help=""
              rules={ rules.Departamento }
              value={ data.Departamento }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm="12" md="4">
            <FormControl type="select"
              label="Tipo Contrato"
              name="TipoContrato"
              placeholder=""
              help=""
              rules={ rules.TipoContrato }
              value={ data.TipoContrato }
              options={ catalogos.tipoContrato }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm="12" md="4">
            <FormControl type="select"
              label="Tipo Jornada"
              name="TipoJornada"
              placeholder=""
              help=""
              rules={ rules.TipoJornada }
              value={ data.TipoJornada }
              options={ catalogos.tipoJornada }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm="12" md="4">
            <FormControl type="select"
              label="Sindicalizado"
              name="Sindicalizado"
              placeholder=""
              help=""
              rules={ rules.Sindicalizado }
              value={ data.Sindicalizado }
              options={ this.sindicalizadoOptions }
              onChange={ this.handleOnChange }
            />
          </Col>

        </Row>

        <Row className="py-3">
          <Col>
            <strong className="text-muted text-upper">Datos de pago</strong>
          </Col>
        </Row>

        <Row>

          <Col sm="12" md="4">
            <FormControl type="select"
              label="Periodicidad de Pago"
              name="PeriodicidadPago"
              placeholder=""
              help=""
              rules={ rules.PeriodicidadPago }
              value={ data.PeriodicidadPago }
              options={ catalogos.periodicidadPago }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm="12" md="4">
            <FormControl type="text"
              label="Salario Base de Cotización (SBC)"
              name="SalarioBaseCotApor"
              placeholder="Pago de cuotas y aportaciones de Seguridad Social"
              help=""
              rules={ rules.SalarioBaseCotApor }
              value={ data.SalarioBaseCotApor }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm="12" md="4">
            <FormControl type="text"
              label="Salario Diario Integrado (SDI)"
              name="SalarioDiarioIntegrado"
              placeholder=""
              help=""
              rules={ rules.SalarioDiarioIntegrado }
              value={ data.SalarioDiarioIntegrado }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm="12" md="4">
            <FormControl type="select"
              label="Entidad Federativa"
              name="ClaveEntFed"
              placeholder=""
              help=""
              rules={ rules.ClaveEntFed }
              value={ data.ClaveEntFed }
              options={ catalogos.estados }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row className="py-3">
          <Col>
            <strong className="text-muted text-upper">Datos bancarios</strong>
          </Col>
        </Row>

        <Row>

          <Col sm="12" md="4">
            <FormControl type="select"
              label="Banco"
              name="Banco"
              placeholder=""
              help=""
              rules={ rules.Banco }
              value={ data.Banco }
              options={ catalogos.banco }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm="12" md="4">
            <FormControl type="text"
              label="Cuenta bancaria"
              name="CuentaBancaria"
              placeholder=""
              help=""
              rules={ rules.CuentaBancaria }
              value={ data.CuentaBancaria }
              onChange={ this.handleOnChange }
            />
          </Col>

        </Row>

        {/* TODO: Resolver subcontratación (Unbounded nodes) */}

        {/* <Row className="py-3">
          <Col>
            <strong className="text-muted text-upper">SubContratacion</strong>
          </Col>
        </Row>

        <Row>
          <Col sm="12" md="4">
            <FormControl type="text"
              label="RfcLabora"
              name="RfcLabora"
              placeholder=""
              help=""
              rules={ rules.RfcLabora }
              value={ data.RfcLabora }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm="12" md="4">
            <FormControl type="text"
              label="PorcentajeTiempo"
              name="PorcentajeTiempo"
              placeholder=""
              help=""
              rules={ rules.PorcentajeTiempo }
              value={ data.PorcentajeTiempo }
              onChange={ this.handleOnChange }
            />
          </Col>

        </Row> */}

      </Form>
    )
  }
}

export default ReceptorNominaInfoForm;